export default __webpack_public_path__ + "static/media/lemontbotanique_xl1.96b3942e.png";